import React, { useEffect, useState } from 'react';
import CustomDropDown from '../../shared/components/dropdown/customDropDown';
import CommonTable from '../../shared/components/common-table/commonTable';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import { DeleteCompanyBank, GetCompanyAllBanks } from '../../shared/common/graphqlQuery';
import { Button, message, Skeleton } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { routeConfig } from '../../shared/common/constant';
import { transformPro } from '../../shared/hooks/transfromApiData';
import { companyData } from '../../core/auth';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { useStore } from '../../shared/hooks/stateStore';

let deleteId;
const dropDownButton = {
    name: 'Action '
}
const dropDownElements = [
    {
        key: '0',
        name: 'Edit',
        icon: <EditOutlined />
    },
    {
        key: '1',
        name: 'Delete',
        icon: <DeleteOutlined />
    }
]
const onError = (error: any, result: any) => {

}
const tableConfig = {
    bordered: false,
    loading: false,
    pagination: {
        position: 'bottomRight',
        current: 1,
        pageSize: 10
    },
    showHeader: true,
    tableLayout: undefined,
    // sortDirections: ['ascend' , 'descend','ascend' ]
};
const CompanyAllBanksList = () => {
    const history = useHistory();
    const [companyBankListData, setcompanyBankListData] = useState([]);
    const companyId = companyData().getCompanyData();
    const columns = [
        {
            title: 'Bank Name',
            dataIndex: 'bankName',
            key: 'bankName',
            sorter: true,
        },
        {
            title: 'Account Name',
            dataIndex: 'accountName',
            key: 'accountName',
            sorter: true,
        },
        {
            title: 'Account Number',
            dataIndex: 'acNumber',
            key: 'acNumber',
            sorter: true,
        },
        {
            title: 'Action',
            key: 'action',
            render: (value: any) => (
                <CustomDropDown
                    dropDownButton={dropDownButton}
                    dropDownElements={dropDownElements}
                    rowId={value.key}
                    onclickMenu={(rowId: any, key: any) => openGoToDropdownLink(rowId, key)}>
                </CustomDropDown>
            ),
        },
    ];

    const openGoToDropdownLink = (key: any, value: any) => {
        if (+value.key) {
            deleteId = key;
            DeleteCompanyBankMutation.callMutation({ variables: { deleteCompanyBankInput: { companyId, companyBankId: key } } })
        } else {
            const bankDataIndex = companyBankListData.findIndex(eachBankData => eachBankData.key === key);
            if (bankDataIndex !== -1) {
                useStore.setState({ companyBank: companyBankListData[bankDataIndex] });
                history.push('updateCompanybank/' + key);
            }
        }
    };

    const onDeleteCompanyBank = (result: any) => {
        const constData = [...companyBankListData];
        const deletedIndex = constData.findIndex(eachData => eachData.key === deleteId);
        constData.splice(deletedIndex, 1);
        setcompanyBankListData([...constData]);
        message.success(result.deleteCompanyBank.message);
    }

    const { loading, data } = useQueryHook(GetCompanyAllBanks, { companyId: companyId });
    const DeleteCompanyBankMutation = useMutationHook(DeleteCompanyBank, onDeleteCompanyBank, onError);


    const companyBankList = data?.getCompanyAllBanks;
    useEffect(() => {
        setcompanyBankListData(transformPro(companyBankList))
    }, [companyBankList]);
    const addInvoiceFunc = () => {
        history.push(routeConfig.addcompanyBank.path);
    }
    return (
        <>
            {
                loading ? <Skeleton active /> : <CommonTable
                    className="my-component"
                    tableConfig={tableConfig}
                    columns={columns}
                    showDeletedInvoices={true}
                    allowDeletedData={false}
                    addBtnString='Add Company Bank'
                    btnCallFunc={addInvoiceFunc}
                    tableRowdata={companyBankListData} />
            }
        </>
    );
}
export default CompanyAllBanksList